import { z } from 'zod';
import { t } from 'i18next';
import { peselSchema } from '@repo/shared/types';

import { companySchema } from './company.schema';

export const jdgCompanySchema = z
  .object({
    pesel: peselSchema,
  })
  .extend(companySchema.shape)
  .extend({
    documentId: z.string().min(1, t('loanFormPage.borrowerDetails.form.validation.documentNumber')),
  });
